import { useState } from 'react';

import { IconAngleRight, IconCalendar } from '@iwoca/icons';
import { Button, Modal } from '@iwoca/orion';
import { FormattedMessage } from 'react-intl';

import { TUseRCFWithdrawFunds } from './useRCFWithdrawFunds';
import { PaymentPlanModalContent } from '../../../myOffers/approvedView/RCFApprovedView/RCFRepaymentSchedule/PaymentPlanModalContent';

export const ViewNewPaymentPlan = ({
    drawdownAmount,
    accessPeriod
}: {
    drawdownAmount: number;
    accessPeriod: TUseRCFWithdrawFunds['formalOfferAccessPeriod'];
}) => {
    const [showPaymentPlan, setShowPaymentPlan] = useState(false);

    return (
        <>
            <Modal
                isOpen={showPaymentPlan}
                onClose={() => setShowPaymentPlan(false)}
                closeIcon
            >
                {showPaymentPlan && (
                    <PaymentPlanModalContent
                        offer={{
                            offer_id: accessPeriod.offer_id,
                            max_amount: accessPeriod.max_amount
                        }}
                        initialAmount={drawdownAmount}
                        isInRepaymentFreePeriod={true}
                    />
                )}
            </Modal>

            <Button
                variant="tertiary"
                className="px-0"
                onClick={() => setShowPaymentPlan(true)}
            >
                <IconCalendar />
                <FormattedMessage
                    id="_.outstanding_view.rcf_view_new_payment_plan"
                    defaultMessage="View new payment plan"
                />
                <IconAngleRight />
            </Button>
        </>
    );
};
